import { ArrowRightIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';
import { theme } from '../../config/theme';
import { LanguageSwitcher } from './LanguageSwitcher';

export function SiteHeader() {
  const { t } = useTranslation();

  return (
    <header className="sticky top-0 z-30 border-b border-border bg-surface backdrop-blur">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-5 py-4 sm:px-6 lg:px-8">
        <a href="/" className="flex items-center gap-3 font-semibold text-foreground">
          <span className="grid size-9 place-items-center rounded bg-primary text-sm font-bold text-primary-foreground">
            A
          </span>
          <span>{theme.brand.shortName}</span>
        </a>
        <nav className="hidden items-center gap-7 text-sm font-medium text-muted-foreground md:flex" aria-label={t('header.mainNav')}>
          {theme.nav.map((item) => (
            <a key={item.href} href={item.href} className="transition hover:text-foreground">
              {t(`nav.${item.key}`)}
            </a>
          ))}
        </nav>
        <div className="flex items-center gap-2">
          <LanguageSwitcher />
          <a
            href="/app/"
            className="inline-flex items-center justify-center gap-2 rounded bg-primary px-4 py-2 text-sm font-semibold text-primary-foreground ring-1 ring-primary-hover transition hover:bg-primary-hover focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring disabled:cursor-not-allowed disabled:opacity-60"
          >
            {t('header.signIn')}
            <ArrowRightIcon className="size-4" aria-hidden="true" />
          </a>
        </div>
      </div>
    </header>
  );
}
